"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _IconButton = _interopRequireDefault(require("@mui/material/IconButton/IconButton.js"));

var _FormControl = _interopRequireDefault(require("@mui/material/FormControl/FormControl.js"));

var _TextField = _interopRequireDefault(require("@mui/material/TextField/TextField.js"));

var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles/makeStyles.js"));

var _Plus = _interopRequireDefault(require("../../assets/Icons/Plus"));

var _Minus = _interopRequireDefault(require("../../assets/Icons/Minus"));

var _Colors = _interopRequireDefault(require("../../styles/Colors"));

var _Input = require("../Input");

var _excluded = ["width", "className", "margin", "nsValue", "onChangeHandler", "hint", "minValue", "maxValue", "step"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var inputStyle = (0, _makeStyles.default)({
  root: _objectSpread(_objectSpread({}, _Input.inputBaseStyles), {}, {
    width: function width(props) {
      return props.width;
    },
    '& .MuiInputLabel-root': {
      width: '100%',
      display: 'flex',
      fontSize: '15px',
      fontFamily: 'Lato',
      justifyContent: 'center'
    },
    '& .MuiInputLabel-filled': {
      transform: 'translate(0px, 20px) scale(1)'
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(12.5%, 10px) scale(0.75)'
    },
    '& .MuiInputBase-root': {
      height: '56px',
      borderBottom: "4px solid ".concat(_Colors.default.secondaryGrey),
      borderRadius: '4px',
      backgroundColor: _Colors.default.lightestGrey,
      fontSize: '15px',
      padding: '10px 48px'
    },
    '&.isReadOnly': {
      '& .MuiInputBase-root': {
        borderBottomColor: _Colors.default.secondaryGrey,
        opacity: 0.5,
        '& > input': {
          textAlign: 'center'
        }
      },
      '& .MuiFormLabel-root': {
        color: _Colors.default.secondaryGrey
      },
      '& .MuiFormLabel-root.Mui-focused': {
        color: _Colors.default.secondaryGrey
      }
    }
  })
});
var buttonStyle = (0, _makeStyles.default)({
  root: {
    position: 'absolute',
    width: '32px',
    height: '32px',
    borderRadius: '4px',
    pointerEvents: 'initial',
    background: _Colors.default.lightGrey,
    padding: 0,
    top: '10px',
    '&.minus': {
      marginLeft: '8px',
      left: '0px'
    },
    '&.plus': {
      marginRight: '8px',
      right: '0px'
    },
    '&:hover': {
      backgroundColor: _Colors.default.lightGrey
    }
  }
});

var changeHandler = function changeHandler(value, ocHandler, min, max) {
  var convertedValue = Number(value);

  if (value === '') {
    ocHandler(undefined);
    return;
  }

  if (Number.isNaN(convertedValue)) {
    ocHandler(0);
    return;
  }

  if ((min || min === 0) && convertedValue < min) {
    ocHandler(min);
    return;
  }

  if ((max || max === 0) && convertedValue > max) {
    ocHandler(max);
    return;
  }

  ocHandler(convertedValue);
};

var increase = function increase(ocHandler, value, step) {
  if (value !== null && value !== undefined) {
    var newValue = step ? value + step : value + 1;
    ocHandler(newValue);
  }
};

var decrease = function decrease(ocHandler, value, step) {
  if (value !== null && value !== undefined) {
    var newValue = step ? value - step : value - 1;
    ocHandler(newValue);
  }
};

var NumberStepper = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '156px' : _ref$width,
      className = _ref.className,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? '0' : _ref$margin,
      nsValue = _ref.nsValue,
      onChangeHandler = _ref.onChangeHandler,
      _ref$hint = _ref.hint,
      hint = _ref$hint === void 0 ? '' : _ref$hint,
      minValue = _ref.minValue,
      maxValue = _ref.maxValue,
      step = _ref.step,
      rest = _objectWithoutProperties(_ref, _excluded);

  var disabled = rest.disabled,
      error = rest.error,
      inputProps = rest.inputProps;
  var classes = inputStyle({
    width: width
  });
  return /*#__PURE__*/_react.default.createElement(_FormControl.default, {
    ref: ref,
    className: className,
    style: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      fontFamily: 'Lato',
      position: 'relative',
      margin: margin,
      width: width
    }
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({
    classes: classes,
    className: "".concat(inputProps !== null && inputProps !== void 0 && inputProps.readOnly ? 'isReadOnly' : '', " ").concat(disabled ? 'isDisabled' : ''),
    variant: "filled",
    type: "string",
    helperText: /*#__PURE__*/_react.default.createElement("span", {
      style: {
        display: 'block',
        color: error ? _Colors.default.warningRed : _Colors.default.secondaryGrey
      }
    }, hint),
    color: "primary",
    value: nsValue,
    inputProps: {
      style: {
        textAlign: 'center'
      }
    },
    onChange: function onChange(e) {
      return changeHandler(e.currentTarget.value, onChangeHandler, minValue, maxValue);
    },
    onBlur: function onBlur(e) {
      return changeHandler(e.currentTarget.value, onChangeHandler, minValue, maxValue);
    }
  }, rest)), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: '100%',
      display: 'flex',
      width: '100%',
      position: 'absolute',
      backgroundColor: '(0, 0, 0, 0)',
      pointerEvents: 'none'
    }
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    className: "minus",
    classes: buttonStyle(),
    disableRipple: true,
    onClick: function onClick() {
      return decrease(onChangeHandler, nsValue, step);
    },
    disabled: nsValue === null || nsValue === undefined
  }, /*#__PURE__*/_react.default.createElement(_Minus.default, {
    width: 32,
    height: 32
  })), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    className: "plus",
    classes: buttonStyle(),
    disableRipple: true,
    onClick: function onClick() {
      return increase(onChangeHandler, nsValue, step);
    },
    disabled: nsValue === null || nsValue === undefined
  }, /*#__PURE__*/_react.default.createElement(_Plus.default, {
    width: 32,
    height: 32
  }))));
});

var _default = NumberStepper;
exports.default = _default;